// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2MIZ4","modalFooterButton":"ModalNotes_modalFooterButton__HqKWn"};